import { render, staticRenderFns } from "./NuevoCargo.vue?vue&type=template&id=b7aad5fe&"
import script from "./NuevoCargo.vue?vue&type=script&lang=js&"
export * from "./NuevoCargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports